import { render, staticRenderFns } from "./oqcOrderListPage.vue?vue&type=template&id=2515eacc&scoped=true&"
import script from "./oqcOrderListPage.vue?vue&type=script&lang=js&"
export * from "./oqcOrderListPage.vue?vue&type=script&lang=js&"
import style0 from "./oqcOrderListPage.vue?vue&type=style&index=0&id=2515eacc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2515eacc",
  null
  
)

export default component.exports